export default {
	messages: {
		general: {
			no_alerts: "Aucune alerte trouvée",
			no_attachments: "On dirait que vous êtes un peu à court de pièces jointes",
			drop_files_here: "Déposez vos fichiers ici",
			no_values_for_this_date: "Aucune valeur trouvée pour cette date",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/messages/messages_fr.js